import { render, staticRenderFns } from "./select-brands.vue?vue&type=template&id=cf99bc26&scoped=true"
import script from "./select-brands.vue?vue&type=script&lang=js"
export * from "./select-brands.vue?vue&type=script&lang=js"
import style0 from "./select-brands.vue?vue&type=style&index=0&id=cf99bc26&prod&lang=css"
import style1 from "./select-brands.vue?vue&type=style&index=1&id=cf99bc26&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf99bc26",
  null
  
)

export default component.exports